import axios from 'axios'
import { BUSCAR_CAIXA_ABERTO } from '../../types'
import { SLOW_REQUEST_CONFIG } from '../../../util/loadingUtil'
import { RESPONSE_ERROR_HANDLER_POSTPONE_HEADER } from '../../../util/responseUtil'
import { URL } from '../../../util/ambienteActions';
import { salvarCacheCaixaAberto, carregarCacheCaixaAberto } from '../../../util/offlineStorage';

const OFFLINE_AWARE_CONFIG = {
  headers: {
    ...SLOW_REQUEST_CONFIG.headers,
    [RESPONSE_ERROR_HANDLER_POSTPONE_HEADER]: true
  }
}

export default function buscarCaixaAberto (codigoEmpresa) {
  const url = `${URL}/fechamento-caixa-usuario/empresa/${codigoEmpresa}/usuario/caixa-aberto`;
  return dispatch => axios.get(url, OFFLINE_AWARE_CONFIG)
    .then(response => {
      salvarCacheCaixaAberto(codigoEmpresa, response.data);
      return dispatch({ type: BUSCAR_CAIXA_ABERTO, payload: response });
    })
    .catch(erro => {
      if (!navigator.onLine || !erro.response) {
        const cache = carregarCacheCaixaAberto(codigoEmpresa);
        return dispatch({ type: BUSCAR_CAIXA_ABERTO, payload: { data: cache !== null ? cache : true } });
      }
      throw erro;
    });
}
